import React, { useEffect, useState } from 'react';
import styles from './ResearchOpportunityTable.module.scss';
import deleteIcon from '../../../assets/Imagess/greenDelete.svg';
import editIcon from '../../../assets/Imagess/greenEdit.svg';
import morInfo from '../../../assets/icons/programs/major/moreInfo.svg';

import TablePagination from '../Pagination/TablePagination';
import Loader from '../Loader/Loader';

import MoreButton from '../Custom/MoreButton';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import DeletePopup from '../Custom/DeletePopup';
import { useDeleteAlumniStudent } from '../../../Hooks/Alumni';
import { useToast } from '../Custom/CustomToaster/Toast';
import { useDeleteResearch } from '../../../Hooks/Research';
import NoDataComponent from '../Custom/NoDataComponent/NoDataComponent';

const ResearchOpportunityTable = ({
  tableHeader,
  data,
  page,
  setPage,
  setPageSize,
  pageSize,
  isUsersLoading,
  refetchUsers,
}) => {
  const navigate = useNavigate();
  const itemsPerPage = data?.pageSize;
  const totalItems = data?.totalCount;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedUser, setSelectedUser] = useState('');
  const customizedToast = useToast();
  const { mutate, isLoading, isSuccess } = useDeleteResearch(selectedUser);

  useEffect(() => {
    if (isSuccess) {
      customizedToast.open('تم الحذف بنجاح');
      setShowDeletePopup(false);
      refetchUsers();
    }
  }, [isSuccess]);

  if (isUsersLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className={styles['container']}>
        <table className={styles['userstable-container']}>
          <thead>
            <tr>
              {tableHeader &&
                tableHeader?.map((item, index) => {
                  return (
                    <th
                      className={`${
                        item.flag
                          ? styles.lastRadius
                          : index === 0
                          ? styles.firstRadius
                          : ''
                      }`}
                      colSpan={item.colSpan}
                      key={index}
                    >
                      {item.name}{' '}
                      {/* <img
                        className={styles["pointer"]}
                        src={upArrow}
                        alt="icon"
                        onClick={() => handleOrder(item.originalName)}
                      />
                      <img
                        className={styles["pointer"]}
                        src={downArrow}
                        alt="icon"
                        onClick={() => handleOrder(item.originalName)}
                      /> */}
                    </th>
                  );
                })}
            </tr>
          </thead>
          <tbody>
            {data?.items?.length > 0 ? (
              data?.items?.map((item, index) => (
                <tr key={index}>
                  <td colSpan={2} className={styles.firstRadius}>
                    {item.titleAR}
                  </td>
                  <td>{item.department?.text_AR}</td>
                  <td>{item?.email}</td>
                  <td>{moment(item?.publicationDate).format('DD/MM/YYYY')}</td>
                  <td
                    className={`${styles.lastRadius} ${styles['icon-cont-table']}`}
                  >
                    <MoreButton icon={morInfo} left="0">
                      <div className="profile-container">
                        <div
                          onClick={() =>
                            navigate(
                              `/home/edit-research-opportunity/${item?.researchOpportunityId}`
                            )
                          }
                        >
                          <img src={editIcon} alt="editIcon" /> <h4>تعديل</h4>{' '}
                        </div>
                        <div
                          onClick={() => {
                            setSelectedUser(item?.researchOpportunityId);
                            setShowDeletePopup(true);
                          }}
                        >
                          <img src={deleteIcon} alt="deleteIcon" /> <h4>حذف</h4>{' '}
                        </div>
                      </div>
                    </MoreButton>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={tableHeader?.length + 1}>
                  <NoDataComponent />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {showDeletePopup && (
        <DeletePopup
          handleOnClose={() => setShowDeletePopup(false)}
          title="بحث"
          handleDelete={() => {
            mutate();
          }}
          isLoading={isLoading}
        />
      )}
      <div className={styles.paginator}>
        <TablePagination
          totalPages={totalPages}
          page={page}
          setPage={setPage}
          itemsPerPage={pageSize}
          setPageSize={setPageSize}
        />
      </div>
    </>
  );
};

export default ResearchOpportunityTable;
